import { Link } from "react-router-dom";
import { FiArrowUpRight, FiBookmark, FiGift, FiSmartphone } from "react-icons/fi";
import CatalogueCover from "../Books/CatalogueCover";
import { catalogueBookPath, enabled } from "../Books/catalogueBookDetails";

export default function LibraryBookCard({ book, location, onRead }) {
	const path = catalogueBookPath(book, location);
	const lastPage = Number(book.read_tracker?.last_page);
	return (
		<article className="shelf-book">
			<Link to={path} className="shelf-book-art" aria-label={"View details: " + book.title}>
				<div className="shelf-book-cover"><CatalogueCover book={book} /></div>
				{enabled(book.is_gifted) && <span className="shelf-gift"><FiGift aria-hidden="true" />Gift received</span>}
				<span className="shelf-book-open" aria-hidden="true"><FiArrowUpRight /></span>
			</Link>
			<div className="shelf-book-body">
				<p className="shelf-book-category">{book.category?.name || "Your collection"}</p>
				<h3><Link to={path}>{book.title}</Link></h3>
				<p className="shelf-book-author">{book.author || "Author not listed"}</p>
				<div className="shelf-book-meta">{Number.isInteger(lastPage) && lastPage > 1
					? <span><FiBookmark aria-hidden="true" />Last saved on page {lastPage.toLocaleString()}</span>
					: <span>{enabled(book.isFree) ? "Free book" : "In your collection"}</span>}</div>
				<div className="shelf-book-actions">
					<button type="button" onClick={() => onRead(book)} aria-label={"Read in app: " + book.title}><FiSmartphone aria-hidden="true" />Read in app</button>
					<Link to={path} aria-label={"Book details: " + book.title}>Details<FiArrowUpRight aria-hidden="true" /></Link>
				</div>
			</div>
		</article>
	);
}
